module.exports = __webpack_public_path__ + "img/logo2.88d10379.png";